<template>
    <div class="mobile-carousel">

        <div class="carousel-container">
            <div class="text-box">
                <div class="en-desc">NEW PLATFORM FOR ART DISSEMINATION</div>
                <div class="cn-desc">艺术传播新平台</div>
                <div class="btn-box">
                    <div class="btn">
                        保障艺术家权益
                    </div>
                    <div class="btn">
                        重塑艺术界生态
                    </div>
                    <div class="btn">
                        守护艺术品价值
                    </div>
                </div>
            </div>
            <!-- 轮播卡片容器 -->
            <div class="carousel-cards" ref="carouselContainer">
                <!-- 轮播卡片 - 添加active动态类 -->
                <div class="carousel-card" v-for="(item, index) in artList" :key="index" :style="getCardStyle(index)"
                    :class="{ 'active': index === currentIndex }">
                    <img :src="item.imageUrl" :alt="item.name" class="card-image" />
                    <div class="card-info">
                        <h3 class="card-title">{{ item.name }}</h3>
                        <p class="card-creator">{{ item.creator }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getArtshare } from '@/api/getArtshare'
export default {
    name: 'MobileCardCarousel',
    data () {
        return {
            // 轮播数据 - 实际项目中可替换为API请求
            artList: [],
            currentIndex: 1, // 默认居中显示第二个作品
            startX: 0,
            isDragging: false,
            containerWidth: 0
        }
    },
    async created () {
        const data = await getArtshare()
        this.artList = data
        console.log('获取到的艺术作品数量:', this.artList)
    },

    mounted () {
        // 初始化容器宽度并监听窗口变化
        this.containerWidth = this.$refs.carouselContainer.offsetWidth
        window.addEventListener('resize', this.handleResize)
        this.setupTouchEvents()
    },
    beforeUnmount () {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        // 获取卡片样式 - 根据位置计算覆盖关系
        getCardStyle (index) {
            const distance = index - this.currentIndex
            let transform = 'translateX(0)'
            let zIndex = 100
            const cardWidth = this.containerWidth * 0.8 // 卡片宽度为容器的80%

            // 根据距离当前索引的位置计算偏移量
            if (distance < 0) {
                // 左侧卡片 - 盖住80%，露出20%
                transform = `translateX(-${Math.abs(distance) * 80}%)`
                zIndex = 100 - Math.abs(distance)
            } else if (distance > 0) {
                // 右侧卡片 - 盖住80%，露出20%
                transform = `translateX(${distance * 80}%)`
                zIndex = 100 - distance
            } else {
                // 当前卡片 - 居中显示
                transform = 'translateX(0)'
                zIndex = 100
            }

            return {
                width: `${cardWidth}px`,
                transform: `translateX(-50%) ${transform}`,
                zIndex,
                transition: this.isDragging ? 'none' : 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
            }
        },

        // 设置触摸事件监听
        setupTouchEvents () {
            const container = this.$refs.carouselContainer
            if (!container) return

            // 触摸开始
            container.addEventListener('touchstart', (e) => {
                this.isDragging = true
                this.startX = e.touches[0].clientX
            })

            // 触摸移动 - remove unnecessary return statement
            container.addEventListener('touchmove', (e) => {
                // Remove: if (!this.isDragging) return
                // 这里不直接更新位置，只在结束时判断方向
            })

            // 触摸结束
            container.addEventListener('touchend', (e) => {
                if (!this.isDragging) return
                this.isDragging = false

                const endX = e.changedTouches[0].clientX
                const diffX = endX - this.startX
                const threshold = 50 // 最小滑动距离阈值

                // 判断滑动方向 - 修改右侧滑动条件
                if (diffX > threshold && this.currentIndex > 0) {
                    // 向右滑动，显示上一个
                    this.currentIndex--
                } else if (diffX < -threshold && this.currentIndex < this.artList.length - 1) {
                    // 向左滑动，显示下一个 - 修复边界判断
                    this.currentIndex++
                }
            })
        },

        // 窗口大小变化处理
        handleResize () {
            this.containerWidth = this.$refs.carouselContainer.offsetWidth
        }
    }
}
</script>

<style lang="less" scoped>
.mobile-carousel {
    width: 100%;
    height: 100%;
    padding-top: 100px;
    box-sizing: border-box;

    .text-box {
        width: 100%;
        height: auto;
        padding-bottom: 50px;
        box-sizing: border-box;

        .en-desc {
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            color: #7F7E7C;
            text-align: center;
        }

        .cn-desc {
            font-size: 28px;
            line-height: 30px;
            color: #FC7A3A;
            font-weight: bolder;
            text-align: center;
        }

        .btn-box {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 !important;
            margin-top: 20px;

            .btn {
                width: 110px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                border-radius: 15px;
                font-size: 14px;
                color: #fff;
                background-color: #FF7A3B;
            }

        }
    }

    .carousel-container {
        width: 100%;
        position: relative;
        height: 320px; // 固定高度
    }

    .carousel-cards {
        width: 100%;
        height: 100%;
        position: relative;

    }

    .carousel-card {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 350px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        background-color: white;
        z-index: 9;
        // 修复：使用::v-deep穿透scoped样式，并修正选择器写法

        .card-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .card-info {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 16px;
            background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
            color: white;

            .card-title {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 4px;
            }

            .card-creator {
                font-size: 14px;
                opacity: 0.9;
            }
        }
    }

    ::v-deep .carousel-card:not(.active)::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
        pointer-events: none;
        transition: background 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
}
</style>